import type { IApiResourceResponse } from '@/services';
import type { IResourceData } from '@/entities';

export const mapApiResource = (data: Readonly<IApiResourceResponse>): IResourceData => {
  return {
    id: data.id,
    description: data.description,
    imageUrl: data.imageUrl,
    order: data.order,
    header: data.header,
    url: data.url
  };
};
